export default "__VITE_ASSET__DuIovuEN__"